
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDeKvwYAEuWpEDuAMghtA4rxw30pJ7l4dJjFBhfhKgbsMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/index.vue?macro=true";
import { default as _91id_939H6z9Tn57LHmYg550SQKosfyI7syvx3WGkL1U8N17W0Meta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/wiki/[id].vue?macro=true";
import { default as logine56UQA1qojIRUvJMzD48DxwRCa8FR0mGsPkUTIGMBmAMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/login.vue?macro=true";
import { default as index2t1pExdC8_wpqGPtELGm74yD4lY8639_45jNAfN8gMLacMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/wiki/index.vue?macro=true";
import { default as _91id_934Vta9dqmGhNwO3E6ctPExJmiNRsNZqMwXg3Fk2213LsMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/[id].vue?macro=true";
import { default as _91id_93J_z47EtUV_Sh9rBAa6AvDlQdQi_PDeO_452otVxIdz6R0Meta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/reports/[id].vue?macro=true";
import { default as indexgoAJB5i5w10jFi0b6uWn1n_45waSbaqNmsgT_45uUmtExtYMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/index.vue?macro=true";
import { default as indexBVRRBDRAyk80RjMSsfMEIo0jK7TrTdiqeueBcGTShkoMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/profile/index.vue?macro=true";
import { default as _91id_93TK_yAyERb9oSvfXVJAMEwWXQoE26jv12O3hn8LkEMH0Meta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/[id].vue?macro=true";
import { default as _91id_93NxwcE_45KhKHjCF3AvuEEA3ZcN6y3fYufjYwsvvrERbS0Meta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/settings/[id].vue?macro=true";
import { default as two_45steps9KxVYufB3VAMjr1vrzclZkbWZsaMnFHORZxy6EfVq9YMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/two-steps.vue?macro=true";
import { default as _91id_93LJpLK7a5Ei2rCqHfl293lvjXccrE6A1wuJBgwwOl46gMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/employees/[id].vue?macro=true";
import { default as indexpQ2GLaSXuOJJ0s1msQv68gGCda3Mwa4n_45MNg6_45EiYPsMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/index.vue?macro=true";
import { default as indexHlU6B3dS9uM_45hpbe4c1YProE_EGu7iKHO7KGpi7QG9EMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/settings/index.vue?macro=true";
import { default as _91id_93LJ3bymdCMHpBt8z9HChsrIlGsa4qf5l3WmnEuWntIKIMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/checklists/[id].vue?macro=true";
import { default as indexpjyhSJw36QDzVFRjNJVBCnGUYpgQIhMuBJ06hS7kFhoMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/employees/index.vue?macro=true";
import { default as _91id_93SkhWT7_45n0_45MqcltwXU_450PeIEHNR7THFNY4MdGBoxZJMMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/responsibles/[id].vue?macro=true";
import { default as _91id_93SMFmJD2xLa_457XUisQV_kab6Ps_kGm_45wbsAOviCaa8pwMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/prescriptions/[id].vue?macro=true";
import { default as indexjATPs5RB473oS0GFeN_45jMWjH8z0dXXzoYqdux8DHRwcMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/responsibles/index.vue?macro=true";
import { default as _91id_93TgvFJqdxj9ADR700YpMpNkEZKVngoOVTKbWHfJM4TPIMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/wiki/articles/[id].vue?macro=true";
import { default as reset_45password_ok2I1Ty4HvxKx7QBD4OJaGDITewP6tyHVFKa43loOcMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/reset-password.vue?macro=true";
import { default as forgot_45passwordOyulRgQIlp_45OREAY2vOVdBkMXaGP_45wf_45FBYxgxQYL_sMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/forgot-password.vue?macro=true";
import { default as _91id_93954_45jSPWCAkIERBoUSo_JOC3d27SEphLZAeCLJ4nkykMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/documents/[id].vue?macro=true";
import { default as _91id_936I_456JaWEXsTIEPYPsI3GePIsRPZrJo1xruccRx9HYVYMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/documents/[id].vue?macro=true";
import { default as _91id_93P1OtDDB7HebTfh50Rae2qABx3eDv5w_45A5WvLgtPs0kYMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/documents-preview/[id].vue?macro=true";
import { default as _91id_93x8wVHMyxIdpMzSQX0ruys4U8QPP9VcK_F1aEYfJ0G9QMeta } from "/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/documents-preview/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/index.vue")
  },
  {
    name: "wiki-id",
    path: "/wiki/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/wiki/[id].vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: logine56UQA1qojIRUvJMzD48DxwRCa8FR0mGsPkUTIGMBmAMeta || {},
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/login.vue")
  },
  {
    name: "wiki",
    path: "/wiki",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/wiki/index.vue")
  },
  {
    name: "objects-id",
    path: "/objects/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/[id].vue")
  },
  {
    name: "reports-id",
    path: "/reports/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/reports/[id].vue")
  },
  {
    name: "objects",
    path: "/objects",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/profile/index.vue")
  },
  {
    name: "projects-id",
    path: "/projects/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/[id].vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/settings/[id].vue")
  },
  {
    name: "auth-two-steps",
    path: "/auth/two-steps",
    meta: two_45steps9KxVYufB3VAMjr1vrzclZkbWZsaMnFHORZxy6EfVq9YMeta || {},
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/two-steps.vue")
  },
  {
    name: "employees-id",
    path: "/employees/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/employees/[id].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/settings/index.vue")
  },
  {
    name: "checklists-id",
    path: "/checklists/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/checklists/[id].vue")
  },
  {
    name: "employees",
    path: "/employees",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/employees/index.vue")
  },
  {
    name: "responsibles-id",
    path: "/responsibles/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/responsibles/[id].vue")
  },
  {
    name: "prescriptions-id",
    path: "/prescriptions/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/prescriptions/[id].vue")
  },
  {
    name: "responsibles",
    path: "/responsibles",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/responsibles/index.vue")
  },
  {
    name: "wiki-articles-id",
    path: "/wiki/articles/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/wiki/articles/[id].vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45password_ok2I1Ty4HvxKx7QBD4OJaGDITewP6tyHVFKa43loOcMeta || {},
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/reset-password.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordOyulRgQIlp_45OREAY2vOVdBkMXaGP_45wf_45FBYxgxQYL_sMeta || {},
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/auth/forgot-password.vue")
  },
  {
    name: "objects-documents-id",
    path: "/objects/documents/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/documents/[id].vue")
  },
  {
    name: "projects-documents-id",
    path: "/projects/documents/:id()",
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/documents/[id].vue")
  },
  {
    name: "objects-documents-preview-id",
    path: "/objects/documents-preview/:id()",
    meta: _91id_93P1OtDDB7HebTfh50Rae2qABx3eDv5w_45A5WvLgtPs0kYMeta || {},
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/objects/documents-preview/[id].vue")
  },
  {
    name: "projects-documents-preview-id",
    path: "/projects/documents-preview/:id()",
    meta: _91id_93x8wVHMyxIdpMzSQX0ruys4U8QPP9VcK_F1aEYfJ0G9QMeta || {},
    component: () => import("/home/andrej/Документи/freelance/admin.qcontrol.su/pages/projects/documents-preview/[id].vue")
  }
]